module.exports = __webpack_public_path__ + "static/img/3.db9bbd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/1/3.png
// module id = VmLX
// module chunks = 0